var React = require('react');

function UpInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M16.8,7.6L9.7,0.4c-0.6-0.6-1.5-0.6-2.1,0L0.4,7.6C0,8-0.1,8.6,0.1,9.2c0.2,0.6,0.8,0.9,1.4,0.9H6\n\tc0.2,0,0.4,0.2,0.4,0.4v23.1c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2V10.5c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h4.5\n\tc0.6,0,1.1-0.4,1.4-0.9C17.4,8.6,17.3,8,16.8,7.6z","key":1})]);
}

UpInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 17.3 35.9","style":{"enableBackground":"new 0 0 17.3 35.9"},"xmlSpace":"preserve"};

module.exports = UpInline;

UpInline.default = UpInline;
